import _ from 'underscore';
import { defaultMetrics } from '@bingads-webui-campaign-legacy/dashboard-cards/performance-card/defaultMetrics';
import config from '@bingads-webui-component-legacy/config/index';
import { allMetrics } from '@bingads-webui-campaign/overview-cards-common';
import {
  setPreferenceForCard,
  getPreferenceForDashboard,
  getCardPreferenceOptions
} from '@bingads-webui-campaign/fluent-page-data';

const permissions = config.get('Permissions');
const validMetricIndexes = [0, 1, 2, 3];
const defaultSelectedMetricIndexes = [0, 1];
const availableMetricKeys = allMetrics(permissions);

export function getPreference({
  preferenceService,
  preferenceName,
  dashboardPreferenceKey,
  cardId,
  activity,
}) {
  const get = () => {
    const boardPreference = getPreferenceForDashboard({ preference: preferenceService, preferenceName, dashboardPreferenceKey });
    let cardPreferenceOptions = getCardPreferenceOptions(boardPreference, cardId);

    if (!cardPreferenceOptions
      || !_.isArray(cardPreferenceOptions.metrics)
      || _.some(cardPreferenceOptions.metrics, metric => !availableMetricKeys.includes(metric))
      || cardPreferenceOptions.metrics.length !== 4
      || !_.isArray(cardPreferenceOptions.selectedMetricIndexes)
      || cardPreferenceOptions.selectedMetricIndexes.length > 4
      || _.some(cardPreferenceOptions.selectedMetricIndexes, index => !validMetricIndexes.includes(index))
    ) {
      activity.trace(`Error preference format for perf chart: ${JSON.stringify(cardPreferenceOptions)}`);
      cardPreferenceOptions = null;
    }

    return cardPreferenceOptions || {
      selectedMetricIndexes: defaultSelectedMetricIndexes,
      // Expert account mode is 1
      metrics: defaultMetrics(permissions, 1),
    };
  };
  const set = (data) => {
    setPreferenceForCard({
      preference: preferenceService,
      preferenceName,
      dashboardPreferenceKey,
      cardId,
      cardOptions: data,
    });
  };

  return {
    get,
    set,
  };
}
